<app-dialog-basic [dialogTitle]="dialogTitle" [isLoading]="bookmarkProblemListCreating">
  <form [formGroup]="addBookmarkProblemListForm">
    <!-- 塾・予備校名 -->
    <mat-form-field class="block mb-4" appearance="outline">
      <mat-label>お気に入りリスト名</mat-label>
      <input matInput formControlName="listName" />
      <mat-error *ngIf="addBookmarkProblemListForm.get('listName').hasError('required')">入力してください</mat-error>
      <mat-error *ngIf="addBookmarkProblemListForm.get('listName').hasError('maxlength')">リスト名は50文字以内にしてください</mat-error>
    </mat-form-field>

    <div class="block mb-4">
      <label class="block mb-2 text-md">公開設定</label>
      <mat-radio-group formControlName="visibility">
        <mat-radio-button class="mr-4" [value]="VisibilityType.PRIVATE">自分のみ</mat-radio-button>
        <mat-radio-button class="mr-4" [value]="VisibilityType.SCHOOL_ONLY">団体内 (※)</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="text-xs">※ 団体内を選択すると、同じ科目にアクセスできる団体メンバー全員が閲覧できます。</div>
  </form>

  <div class="progress-48">
    <mat-spinner [diameter]="48" @enter *ngIf="bookmarkProblemListCreating"></mat-spinner>
  </div>

  <app-dialog-basic-footer>
    <div class="text-danger text-sm mr-auto" @enter *ngIf="errorMessage !== ''">{{ errorMessage }}</div>
    <button mat-stroked-button (click)="cancel()" [disabled]="bookmarkProblemListCreating">キャンセル</button>
    <button mat-flat-button color="primary" (click)="createBookmarkProblemList()" [disabled]="bookmarkProblemListCreating">保存</button>
  </app-dialog-basic-footer>
</app-dialog-basic>
